import axios from 'axios';
import $ from "jquery";

const isLocal = (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "");

const form = $('.form__barcode');
if (form.length) {
    const formBarcode = $('#formBarcode'),
          barcode = $('#barcode'),
          barcodeErrorEmpty = $('.error-barcode-empty'),
          barcodeErrorIncorrect = $('.error-barcode-incorrect'),
          btnNext = $('#btnNext');

    function setError(e, status) {
        if (status) {
            $(e).addClass('is-error')
            $(e).closest(".form__field").find('.form__error').removeClass('hidden')
        } else {
            $(e).removeClass('is-error')
            $(e).closest(".form__field").find('.form__error').addClass('hidden')
        }
    }

    function formHandler() {
        function checkFormFieldsStep() {
            if ($(barcode).val().trim() === '') {
                statusErrorBarcode(barcode, true, 'barcodeEmpty')
                return false;
            }
            if (!barcode.hasClass('is-correct') && $(barcode).val().trim() !== '') {
                statusErrorBarcode(barcode, true, 'barcodeIncorrect')
                return false;
            }
            return true;
        }

        function statusErrorBarcode(e, status, desc = 'correct') {
            if (status) {
                $(e).addClass('is-error');
                if (desc === 'barcodeIncorrect') {
                    $(barcodeErrorIncorrect).removeClass('hidden');
                    $(barcodeErrorEmpty).addClass('hidden');
                    return;
                }
                if (desc === 'barcodeEmpty') {
                    $(barcodeErrorIncorrect).addClass('hidden');
                    $(barcodeErrorEmpty).removeClass('hidden');
                    return;
                }
                $(barcodeErrorIncorrect).addClass('hidden');
                $(barcodeErrorEmpty).addClass('hidden');
            } else {
                $(e).removeClass('is-error');
            }
        }

        $(barcode).on('keyup', function (event) {
            if ($(barcode).val().length > 12) {
                presendForm(event)
            }
        })

        $(barcode).on('input', function (event) {
            if ($(barcode).val().length > 12) {
                presendForm(event)
            }
        })

        $(barcode).on('change', () => {
            if ($(barcode).val().trim() === '') {
                setError($(barcode), true);
            } else {
                setError($(barcode), false);
            }
        });

        function redirectStep1() {
            if (isLocal) {
                window.location.href = 'http://localhost:8081/step1.html?lang=' + locale;
            } else {
                window.location.href = '/princetime/step1?lang' + locale;
            }
        }

        function trimSpaces(str) {
            return str.replace(/\s+/g, '');
        }

        $(btnNext).on('click', function (e) {
            e.preventDefault();
            if (!checkFormFieldsStep()) return;
            
            const formData = {
                barcode: Number($(barcode).val().replace(/\s+/g, ''))
            };
            localStorage.setItem("barcode", formData.barcode);

            $(formBarcode).addClass('is-sending');
            setTimeout(redirectStep1(), 4000);
        });

        function presendForm(e) {
            const url = e.target.dataset.checkApi + Number($(barcode).val().replace(/\s+/g, '')),
                val = e.target.value,
                data = {
                    value: trimSpaces(val)
                };

            if (val === '') {
                statusErrorBarcode(barcode, true, 'barcodeEmpty');
                return;
            } else {
                statusErrorBarcode(barcode, false, 'barcodeEmpty')
            }

            if (isLocal) {
                $(barcode).addClass('is-correct');
                return;
            }

            axios({
                    method: 'GET',
                    url: url,
                    data: data
                })
                .then(function (response) {
                    if (response.data.code_is_valid) {
                        $(barcode).addClass('is-correct');
                    } else if (!response.data.code_is_valid) {
                        if (e.target.id === 'barcode') {
                            statusErrorBarcode(barcode, true, 'barcodeIncorrect')
                        }

                    } else if (response.data['error']) {
                        alert(response.data['error']);
                    }
                })
                .catch(function (response) {
                    /* eslint-disable */
                    console.log(response);
                });
        }
    }
    formHandler();
}